import { createFileRoute } from "@tanstack/react-router";
import { PlatformAuditLogDetailPage } from "@client/components/admin/audit-logs/audit-log-detail-page";

export const Route = createFileRoute("/_app/settings/audit-logs/$id")({
  component: PlatformAuditLogDetailRoute,
});

function PlatformAuditLogDetailRoute() {
  const { id } = Route.useParams();
  return <PlatformAuditLogDetailPage id={id} />;
}
